import { reactive } from 'vue'

import api from '@/store/api'
import { DEFAULT_ENTHUSIASM, DEFAULT_FORMALITY, DEFAULT_TONE } from '@/view/ai/agentVoiceOptions'

const VOICE_FIELDS = [
  'agent_tone',
  'agent_formality_level',
  'agent_enthusiasm_level',
  'agent_emoji_enabled',
  'agent_brand_voice_summary',
  'agent_additional_context'
]

const isSet = value => (typeof value === 'string' ? value.trim() !== '' : value === true)

// True when the merchant has saved any of the six profile voice fields.
export const profileVoiceSet = attributes => VOICE_FIELDS.some(field => isSet(attributes?.[field]))

// The profile's six voice fields, with the defaults for any left blank.
export const voiceFromProfile = (attributes = {}) => ({
  brand_voice_summary: attributes.agent_brand_voice_summary || '',
  emoji_enabled: !!attributes.agent_emoji_enabled,
  additional_context: attributes.agent_additional_context || '',
  tone: attributes.agent_tone || DEFAULT_TONE,
  formality_level: attributes.agent_formality_level || DEFAULT_FORMALITY,
  enthusiasm_level: attributes.agent_enthusiasm_level || DEFAULT_ENTHUSIASM
})

export const profileAttributes = response => response?.data?.data?.attributes || {}

export const PROFILE_REQUEST = 'profile?included=none'

// Brand voice, emoji, additional context and style are set once per merchant
// and shared by every agent, so they live on the profile rather than the agent.
export function useAgentVoiceSettings() {
  const form = reactive({
    brand_voice_summary: '',
    emoji_enabled: false,
    additional_context: '',
    tone: DEFAULT_TONE,
    formality_level: DEFAULT_FORMALITY,
    enthusiasm_level: DEFAULT_ENTHUSIASM
  })

  const read = response => Object.assign(form, voiceFromProfile(profileAttributes(response)))

  const load = () => api.call('GET', PROFILE_REQUEST).then(read)

  const save = () =>
    api
      .call('PUT', 'profile', {
        profile: {
          agent_brand_voice_summary: form.brand_voice_summary,
          agent_emoji_enabled: form.emoji_enabled,
          agent_additional_context: form.additional_context,
          agent_tone: form.tone,
          agent_formality_level: form.formality_level,
          agent_enthusiasm_level: form.enthusiasm_level
        }
      })
      .then(read)

  return { form, load, save }
}
